import { render, staticRenderFns } from "./vgm.vue?vue&type=template&id=0354d3ba&scoped=true"
import script from "./vgm.vue?vue&type=script&lang=js"
export * from "./vgm.vue?vue&type=script&lang=js"
import style0 from "./vgm.vue?vue&type=style&index=0&id=0354d3ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0354d3ba",
  null
  
)

export default component.exports